export const IS_RECALC_SOB = true
export const IS_ALWAYS_SHOW_ACTUALS = true
export const IS_ALWAYS_SHOW_SOB = true
export const IS_QUARTER_DEFAULT = true
export const IS_HIDE_QUOTA_GROW = false
export const IS_BEVEL_ENABLED = false
export const IS_USE_LEVEL_ICON = false
export const IS_SHOW_NULL = true
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS = true
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES = false
export const IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN = false
export const IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING = false
export const IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY = false
export const IS_SHOW_PREV_RECALC_ACTUALS = true
export const IS_SHOW_CY_ACTUALS_COLUMNS = true
export const IS_SHOW_NOT_APPLICABLE = false
export const IS_SHOW_RETAIL_GTM_PRIORITIES = false

export const IS_NEW_LNF = true

export const IS_CALC_FY_SOB_BY_ALL_FQ = true

export const actualsColor = '#217fc3' // Actuals color (blue)
//export const plannedColor = '#fc1a1a' // red
//export const plannedColor2 = '#ff9999' // red pale
export const targetsColor = '2c3038'
export const quotaColor = '#8a1ba1' // Quota violet (violet)
//export const trendColor = '#000000'

export const IS_ENABLE_ROUNDING = true

export const IS_CHECK_SELF_IN_FUTURE_FQ = false
export const IS_CHECK_LAST_PREV_VS_FUTURE = false
